var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html } from 'lit';
import styles from './sds-tree-footer-node.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsTreeNodeBase } from './_sds-tree-node-base';
/**
 * Control represents a sds-tree-footer-node
 */
let SdsTreeFooterNode = (() => {
    let _classDecorators = [sdsCustomElement('sds-tree-footer-node')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTreeNodeBase;
    var SdsTreeFooterNode = _classThis = class extends _classSuper {
        render() {
            return html ` <slot @slotchange="${() => this.handleDataChange()}"></slot> `;
        }
        nodeOrderInView() {
            return 0;
        }
        childAddedCallback() { }
        childRemovedCallback() { }
        /**
         * Add a border on scroll for frozen columns.
         * @param {number} frozenColumnCount The number of frozen columns.
         */
        addBorderOnScroll(frozenColumnCount) {
            const treeNodes = this.querySelectorAll('sds-tree-node');
            treeNodes.forEach(treeNode => {
                const treeCells = Array.from(treeNode.childTreeCells).filter(element => element.tagName.toLowerCase() === 'sds-tree-cell' ||
                    element.tagName.toLowerCase() === 'sds-tree-cell-container');
                if (treeCells.length >= frozenColumnCount && treeCells[frozenColumnCount - 1]) {
                    treeCells[frozenColumnCount - 1].classList.add('sds-tree-cell__scroll-border');
                }
            });
        }
        removeBorderOnScroll(frozenColumnCount) {
            const treeNodes = this.querySelectorAll('sds-tree-node');
            treeNodes.forEach(treeNode => {
                const treeCells = Array.from(treeNode.childTreeCells).filter(element => element.tagName.toLowerCase() === 'sds-tree-cell' ||
                    element.tagName.toLowerCase() === 'sds-tree-cell-container');
                if (treeCells.length >= frozenColumnCount && treeCells[frozenColumnCount - 1]) {
                    treeCells[frozenColumnCount - 1].classList.remove('sds-tree-cell__scroll-border');
                }
            });
        }
        /**
         * Freeze the specified number of columns.
         * @param {number} count The number of columns to freeze.
         */
        freezeColumns(count) {
            const treeNodes = this.querySelectorAll('sds-tree-node');
            treeNodes.forEach(treeNode => {
                const treeCells = Array.from(treeNode.childTreeCells).filter(element => (element.tagName.toLowerCase() === 'sds-tree-cell' ||
                    element.tagName.toLowerCase() === 'sds-tree-cell-container') &&
                    element instanceof HTMLElement);
                if (treeCells.length >= count) {
                    treeCells.slice(0, count).forEach(cell => {
                        cell.classList.add('sds-tree-cell__frozen');
                        cell.freeze();
                    });
                }
            });
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsTreeFooterNode.DATA_FOOTER_CHANGE_EVENT, {
                bubbles: true,
                composed: true,
            }));
        }
        handleDataChange() {
            this.dispatchChange();
        }
    };
    __setFunctionName(_classThis, "SdsTreeFooterNode");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTreeFooterNode = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.DATA_FOOTER_CHANGE_EVENT = 'sds.tree-footer-node.data-changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTreeFooterNode = _classThis;
})();
export { SdsTreeFooterNode };
